import React from "react";
import UserCard from "../components/card";
import axios from "axios";
import Spinner from "../components/spinner";
import SearchBar from "../components/search";
class Home extends React.Component {
  constructor() {
    super();

    this.state = {
      users: [],
      isLoading: true,
      errMsg: "",
      err: false
    };
  }

  componentDidMount() {
    axios
      .get(`https://api.github.com/users?per_page=6`)
      .then(response => {
        response.data.map(user => {
          axios
            .get(`https://api.github.com/users/${user.login}`)
            .then(response => {
              this.setState({
                users: [...this.state.users, response.data],
                isLoading: false
              });
            });
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          err: true,
          errMsg: error.response.data.message
        });
      });
  }

  search = name => {
    this.setState({ isLoading: true, err: false });
    axios
      .get(`https://api.github.com/users/${name}`)
      .then(response => {
        this.setState({ users: [response.data], err: false, isLoading: false });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          err: true,
          errMsg: error.response.data.message,
          users: []
        });
      });
  };

  render() {
    return (
      <div className="Home">
        <SearchBar search={this.search} />
        {this.state.isLoading ? (
          <div className="center-align">
            <Spinner />
          </div>
        ) : (
          <div className="grid">
            {this.state.users.map(user => (
              <UserCard
                key={user.id.toString()}
                login={user.login}
                name={user.name}
                bio={user.bio}
                img={user.avatar_url}
                followers={user.followers}
                repos={user.public_repos}
              />
            ))}
          </div>
        )}

        {this.state.err ? (
          <div>
            <h4> {this.state.errMsg} </h4>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Home;
